export const DRAFT_DOCX_EDITOR_EMPTY_CLASSNAME =
  'flex h-[calc(100vh-220px)] min-h-[620px] items-center justify-center bg-slate-50/80 px-6 text-center text-sm text-slate-500';

export const DRAFT_HISTORY_TAB_ID = 'draft-history';

export const MAX_DRAFT_TITLE_LENGTH = 200;

export const MAX_VISIBLE_COLLABORATOR_INDICATORS = 4;
export const COLLABORATOR_INDICATOR_SIZE_PX = 20;
export const COLLABORATOR_INDICATOR_STEP_PX = 16;

export const AUTOSAVE_IDLE_DELAY_MS = 6000;
export const AUTOSAVE_IDLE_GRACE_MS = 250;
export const AUTOSAVE_IDLE_CALLBACK_TIMEOUT_MS = 2000;

export const DRAFT_LOAD_ERROR_GRACE_MS = 15000;
export const DRAFT_DOCX_ERROR_GRACE_MS = 30000;
export const DRAFT_LIVE_REFRESH_INTERVAL_MS = 3000;
